import { createAction, props } from '@ngrx/store';

import { DcCoreElementType, DcCoreModule } from '../../core/dc-core-types';
import { AppMetadataEntity } from '../../ui/components/app-metadata/app-metadata.entity';
import { ProjectTraceListEntity } from '../components/project-home/project-trace-list.entity';
export enum HomeActions {
	InitProjectHome = '[BE][Project][Home] get project details',
	FetchProjectDetailsSuccess = '[BE][Project][Home] fetch project details success',
	RefreshProjectTraceList = '[BE][Project][Home] refresh element traces',
	FetchElementTracesSuccess = '[BE][Project][Home] fetch element traces success',
	ChangeElementSelection = '[Project][Home] change element selection',
	NavigateToProjectEditRoute = '[Project][Home] navigate to Project edit route',
	NavigateToElementListRoute = '[Project][Home] navigate to element list route',
	NavigateToCreateElementRoute = '[Project][Home] navigate to element create route',
	FetchElementTracesAndCreate = '[BE][Project][Home] fetch element traces and create success',
}

export const initProjectHome = createAction(
	HomeActions.InitProjectHome,
	props<{ id: number; module: DcCoreModule }>()
);

export const changeElementSelection = createAction(
	HomeActions.ChangeElementSelection,
	props<{ element: DcCoreElementType }>()
);

export const fetchProjectDetailsSuccess = createAction(
	HomeActions.FetchProjectDetailsSuccess,
	props<{
		metadata: AppMetadataEntity;
		element: DcCoreElementType;
		stat: Map<DcCoreElementType, number>;
		traces: ProjectTraceListEntity;
		permissions: { create: boolean; edit: boolean };
	}>()
);

export const fetchElementTracesSuccess = createAction(
	HomeActions.FetchElementTracesSuccess,
	props<{ traces: ProjectTraceListEntity }>()
);

export const navigateToProjectEditRoute = createAction(
	HomeActions.NavigateToProjectEditRoute,
	props<{ id: number }>()
);

export const navigateToElementListRoute = createAction(
	HomeActions.NavigateToElementListRoute,
	props<{ id: number; element: DcCoreElementType }>()
);

export const navigateToCreateElementRoute = createAction(
	HomeActions.NavigateToCreateElementRoute,
	props<{ id: number }>()
);

export const refreshProjectTraceList = createAction(
	HomeActions.RefreshProjectTraceList
);

export const fetchElementTracesAndCreate = createAction(
	HomeActions.FetchElementTracesAndCreate,
	props<{ traces: ProjectTraceListEntity; create: boolean }>()
);
